module.exports = __webpack_public_path__ + "img/employee_benefits_hero.02842049.jpg";